module.exports = __webpack_public_path__ + "img/icon-gauge.5902d126.svg";